import axios from '@/lib/axios';
import { PurchaseOrderContractTaskComment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0941. 発注案件契約タスクコメントリアクションtoggle
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:purchase_order_contract_task_id/purchase_order_contract_task_comments/:id/reactions
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
  emoji_id: string;
  content: string;
};
const purchaseOrderContractTaskCommentReaction = (props: Props): Promise<PurchaseOrderContractTaskComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.task_id}/purchase_order_contract_task_comments/${props.id}/reactions`,
    props
  );
};

export const usePurchaseOrderContractTaskCommentReaction = () => {
  return useMutation({
    mutationFn: purchaseOrderContractTaskCommentReaction,
  });
};
